import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PROJECT_URL_SUPABASE;
const supabaseAnonKey = import.meta.env.VITE_ANON_PUBLIC_SUPABASE;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn("Supabase credentials missing in environment variables");
}

export const supabase = createClient(supabaseUrl || '', supabaseAnonKey || '');
